import { render, staticRenderFns } from "./button-group-item.vue?vue&type=template&id=598f9a49&scoped=true&"
import script from "./button-group-item.vue?vue&type=script&lang=js&"
export * from "./button-group-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598f9a49",
  null
  
)

export default component.exports